<template>
    <div class="workflow-layout">
        <mds-layout-grid gutters="none">
            <mds-row align-horizontal="center">
                <mds-col :cols="12" class="page">
                    <div class="header" v-if="$scopedSlots.header">
                        <slot name="header"></slot>
                    </div>
                    <div class="content" :class="{ 'header-space': $scopedSlots.header }">
                        <div class="content__inner">
                            <slot></slot>
                        </div>
                    </div>
                </mds-col>
            </mds-row>
        </mds-layout-grid>
    </div>
</template>

<script>
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";

export default {
    name: "workflow-layout",

    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol
    }
};
</script>

<style lang="scss">
.workflow-layout {
    height: 100%;
    > .mds-layout-grid___hypo,
    > .mds-layout-grid___hypo > .mds-layout-grid__row___hypo {
        height: 100%;
    }

    .page,
    .content,
    .header {
        box-sizing: border-box;
    }

    .page {
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .content {
        flex: 1 1 auto;
        overflow: auto;
        padding: 0 $mds-space-2-x;
    }

    .content__inner {
        margin: 0 $mds-space-2-x;
    }

    .header {
        position: absolute;
        top: 0px;
        left: $mds-space-2-x;
        right: $mds-space-4-x;
        z-index: 1;
        background-color: $mds-color-white;
    }

    .header-space {
        padding-top: 75px;
    }
}
</style>
